import { useEffect } from "react";
import Lenis from "lenis";

export const LenisProvider = ({ children }) => {
  useEffect(() => {
    const lenis = new Lenis({
      lerp: 0.09,
      duration: 1.4,
      smoothWheel: true,
      wheelMultiplier: 1,
    });

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return <>{children}</>;
};
